<template>
  <div
    class="tw:relative tw:cursor-pointer tw:overflow-hidden tw:rounded-xl"
  >
    <img
      class="tw:aspect-video tw:object-cover tw:w-full tw:h-full"
      :src="video.preview_path"
      :alt="video.title"
    >

    <div
      v-if="isPlaying"
      class="tw:bg-black/70 tw:text-white tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center"
    >
      <span>Now Playing</span>
    </div>

    <div
      v-else
      class="tw:bg-black/70 tw:text-white tw:absolute tw:left-0 tw:bottom-0 tw:p-1 tw:text-center tw:text-xs tw:w-full "
    >
      {{ video.title }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  video: {
    type: Object,
    required: true,
  },
  isPlaying: {
    type: Boolean,
    default: false,
  },
})
</script>
